import type { SendAccessConfirmation } from 'v2/interfaces/accessContentConfirmation';

import apiService from './api';
import type { ApiService } from './api';

class AccessContentConfirmationService {
  constructor(private apiService: ApiService) {}

  public sendConfirmation(payload: SendAccessConfirmation) {
    return this.apiService.post('/content-acess-confirmation', payload);
  }
}

const accessContentConfirmationService = new AccessContentConfirmationService(apiService);
export default accessContentConfirmationService;
